
import { declareVrunComponent } from '/vodalys/vvuejs/declareVrunComponent.mjs'

import TroubleshootingSpeaker from './TroubleshootingSpeaker.vue'

declareVrunComponent('troubleshootingSpeaker.vrun.component', TroubleshootingSpeaker)